import BaseEntity from '../BaseEntity.model';
import { AssignedAssessments } from './AssignedAssessments.model';
import Permission from './Permission.model';
import SmartDashboardWidget from './SmartDashboardWidget.model';

export default interface IRole extends BaseEntity {
    Name: string;
    Permissions: Permission[];
    IsCareTeamRole: boolean;
    Widgets: SmartDashboardWidget[];
    ProviderFacilities: any[];
    AssignedAssessments: AssignedAssessments[];
}

export class Role implements IRole {
    Id: string;
    Name: string;
    IsCareTeamRole: boolean;
    Permissions: Permission[];
    Widgets: SmartDashboardWidget[];
    ProviderFacilities: any[];
    AssignedAssessments: AssignedAssessments[];

    constructor() {
        this.Id = '';
        this.Name = '';
        this.Permissions = null;
        this.IsCareTeamRole = false;
        this.Permissions = [];
        this.Widgets = [];
        this.ProviderFacilities = [];
        this.AssignedAssessments = [];
    }
}
